module.exports = __webpack_public_path__ + "static/media/up.32d1271b.svg";